module.exports = __webpack_public_path__ + "static/media/Inter-BlackItalic.4bd1bed6.woff";